import Vue from 'vue'
import Router from 'vue-router'
import store from 'store/app'

import index from '@/views/app/index' //首页
import add from '@/views/app/add' //新增客户
// import addAreaDetails from '@/views/app/addAreaDetails' //新增客户 区
// import addChannelDetails from '@/views/app/addChannelDetails' //新增客户 渠道

import setMeal from '@/views/app/setMeal' //99元套餐
// import setMealAreaDetails from '@/views/app/setMealAreaDetails' //99元套餐 区
// import setMealChannelDetails from '@/views/app/setMealChannelDetails' //99元套餐 渠道
import setMealDepartDetails from '@/views/app/setMealDepartDetails' //渠道详情页

import table from '@/views/app/table' //复杂表格
import table2 from '@/views/app/table2' //复杂表格
import appUsage from '@/views/app/appUsage' //app使用情况
import pdf from '@/views/app/pdf' //pdf查看
import tableDemo from '@/views/app/tableDemo' //复杂表格表头 验证

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      name: '/',
      component: index,
      meta: {
        isShowBottomTab: true,
        keepAlive: true, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        isShowBottomTab: true,
        keepAlive: true, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/table',
      name: 'table',
      component: table,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/table2',
      name: 'table2',
      component: table2,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/add',
      name: 'add',
      component: add,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    // {
    //   path: '/addAreaDetails/:areaId',
    //   name: 'addAreaDetails',
    //   component: addAreaDetails,
    //   meta: {
    //     isShowBottomTab: false,
    //     keepAlive: true,
    //     isBack: false,
    //   }
    // },
    // {
    //   path: '/addChannelDetails/:channelId',
    //   name: 'addChannelDetails',
    //   component: addChannelDetails,
    //   meta: {
    //     isShowBottomTab: false,
    //     keepAlive: false,
    //     isBack: false,
    //   }
    // },
    {
      path: '/setMeal',
      name: 'setMeal',
      component: setMeal,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    // {
    //   path: '/setMealAreaDetails',
    //   name: 'setMealAreaDetails',
    //   component: setMealAreaDetails,
    //   meta: {
    //     isShowBottomTab: false,
    //     keepAlive: true,
    //     isBack: false,
    //   }
    // },
    // {
    //   path: '/setMealChannelDetails',
    //   name: 'setMealChannelDetails',
    //   component: setMealChannelDetails,
    //   meta: {
    //     isShowBottomTab: false,
    //     keepAlive: false,
    //     isBack: false,
    //   }
    // },
    {
      path: '/setMealDepartDetails',
      name: 'setMealDepartDetails',
      component: setMealDepartDetails,
      meta: {
        isShowBottomTab: false,
        keepAlive: false,
        isBack: false,
      }
    },
    {
      path: '/appUsage',
      name: 'appUsage',
      component: appUsage,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: pdf,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
    {
      path: '/tableDemo',
      name: 'tableDemo',
      component: tableDemo,
      meta: {
        isShowBottomTab: false,
        keepAlive: false, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  let { isShowBottomTab = false } = to.meta;
  // document.title = title
  store.commit('SET_PAGE_STATE_ROOT', {
    isShowBottomTab
  });

  next();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js